import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command, CommandBase, FilteredCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Observable } from 'rxjs';
import { BankTransactionImportService } from '../data/bank-transaction-import.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class BankImportBookAsIncorrectPaymentCommandHandler implements ICommandHandler {
  constructor(
    private _service: BankTransactionImportService,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return true;
    }

    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }

    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._service.updateBankTransactionStatus(command.context, command.id).pipe(
        map(() => {
          this._navigationService.reloadAndNavigateToList();
        })
      );
    }

    if (command instanceof FilteredCommand) {
      return this._service
        .bookAsIncorrectPaymentFiltered(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue,
          command.id
        )
        .pipe(
          map(() => {
            this._navigationService.reloadAndNavigateToList();
          })
        );
    }
  }
}
